import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  OnDestroy
} from "@angular/core";
import { IReturnWorstODPairs } from "./models/widget-return-worst-od-pairs";
import { ReturnWorstODPairsService } from "./services/widget-return-worst-od-pairs.service";
import * as HSET from "./settings";
import { GenericUtils } from "./../../../utilities/generic-utils";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: "app-widget-return-worst-od-pairs",
  templateUrl: "./widget-return-worst-od-pairs.component.html",
  styleUrls: ["./widget-return-worst-od-pairs.component.scss"],
  providers: [ReturnWorstODPairsService]
})
export class WidgetReturnWorstODPairsComponent implements OnInit, OnChanges, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  @Input() TITLE: string;
  @Input() HEADINGS: string[] = [];
  @Input() FILTERS: object = {};
  @Input() OPTIONS: object;
  data = null;
  errorMessage = "";
  mockData = null;

  constructor(
    private returnWorstPairService: ReturnWorstODPairsService,
    private utils: GenericUtils
  ) { }

  ngOnInit() {
    this.getReturnWorstPairService();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      JSON.stringify(changes.FILTERS.currentValue) !==
      JSON.stringify(changes.FILTERS.previousValue) &&
      !changes.FILTERS.firstChange
    ) {
      this.getReturnWorstPairService();
    }
  }

  getReturnWorstPairService() {
    this.data = null;
    this.mockData = null;
    this.errorMessage = "";
    const query = JSON.parse(JSON.stringify(this.FILTERS));
    query.limit = "7";

    this.returnWorstPairService.getWorstODPairs(this.OPTIONS, query)
      .pipe(takeUntil(this.unsubscribe)).subscribe(
        response => {
          if (response.data.length > 0) {
            this.data = response.data;
            this.data.map(worstPair => {
              worstPair.value = this.utils.amountIndianUnit(worstPair.value);
              return worstPair;
            });
          } else {
            this.errorMessage = "ERROR_MSG.NO_DATA";
            this.mockData = HSET.data;
            this.HEADINGS = HSET.displayedColumns5;
          }
        },
        error => {
          this.errorMessage = "ERROR_MSG.SYSTEM_ERROR";
          this.mockData = HSET.data;
          this.HEADINGS = HSET.displayedColumns5;
        }
      );
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
  
}

